var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770 430",
    width: 215,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(150.686,0,0,126.315,478.369,151.897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#138387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43bfba"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #131e29 } \n\t\t.s1 { fill: url(#g1) } \n\t\t.s2 { fill: #fefefe } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m916 772h-1080v-1080h1080z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m478.37 153.21l77-0.9 0.15 15.11-63.71 0.74 0.95 39.83 113-1.32-35.44-54.54 19.95-0.23 38.79 57.24-43.66 67.83-14.95 0.18 36.56-56.76-115.22 1.35 1.5 39.83 64.81-0.08-0.39 15.81-78.11 0.91z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m640.29 184.18c-2.57-2.9-2.79-7.39-0.52-10.57l13.83-19.36c1.4-1.97 3.57-3.14 5.88-3.16l0.51-0.01c6.35-0.07 9.92 7.84 5.96 13.19l-14.33 19.36c-2.85 3.84-8.18 4.1-11.33 0.55z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m640.24 227.25l-0.11 0.14c-2.36 3.14-2.37 7.64-0.01 10.78l25.92 34.61c1.53 2.03 3.84 3.2 6.26 3.18 6.62-0.08 10.25-8.35 6.11-13.92l-25.82-34.75c-3.16-4.25-9.16-4.27-12.35-0.04z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m115.1 282.43l-21.25 0.25-1.23-125 21.26-0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m280.44 280.44l-21.7 0.25-84.47-97.17-0.44 0.01 0.97 98.14-20.06 0.24-1.23-125 21.59-0.26 84.47 97.17 0.43-0.01-0.96-98.14 20.17-0.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m454.18 153.42l-61.35 125.74-21.59 0.25-63.15-124.28 22.79-0.27 42.43 90.33q4.77 8.64 8.48 20.28h0.44q3.17-10.02 8.08-20.48l42.39-91.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoo);
export default __webpack_public_path__ + "static/media/logoo.2aceb02be9e293e255d09bc935749406.svg";
export { ForwardRef as ReactComponent };